import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  inject,
  Input,
  Renderer2,
  RendererStyleFlags2,
  ViewChild,
} from '@angular/core';

import { SpaDayLoadDTO } from '@api';

@Component({
  selector: 'spa-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BarChartComponent {
  private renderer = inject(Renderer2);
  private element = inject(ElementRef);

  @Input() loads: SpaDayLoadDTO | undefined;
  @ViewChild('spaDiagram') spaDiagram: ElementRef | undefined;
  parentXPosition: number | null = null;
  DiagramMarking = DiagramMarking;
  timeLabelIndexesBetweenStartAndEnd = [6, 14, 22];

  get xPosition(): number {
    return this.spaDiagram?.nativeElement?.getBoundingClientRect().x;
  }

  @HostListener('window:resize')
  onResize(): void {
    this.parentXPosition = this.xPosition;
  }

  onHover(event: MouseEvent): void {
    const mouseX = event.clientX;
    this.renderer.setStyle(
      this.element.nativeElement,
      `--tooltip-x-position`,
      mouseX - (this.parentXPosition ?? 0) + 'px',
      RendererStyleFlags2.DashCase,
    );
  }

  enteredDiagramElement() {
    if (!this.parentXPosition) {
      this.parentXPosition = this.xPosition;
    }
  }
}

export enum DiagramMarking {
  arrow,
  line,
}
